export const useConstants = () => {
  return {
    routes: {
      api: {
        global: {
          footer: {
            get: "/footer",
          },
          navigation: {
            get: "/navigation",
          },
          global: {
            get: "/global",
          },
        },
        home: {
          get: "/home",
        },
        pages: {
          list: "/pages",
          getById: "/pages/id/:id",
          getBySlug: "/pages/slug/:slug",
        },
        work: {
          list: "/work",
          getBySlug: "/work/slug/:slug",
        },
      },
      response: {
        status: {
          404: 404,
        },
      },
      public: {
        projects: "/work/", // Wat is dit?
      },
    },
    app: {
      title: " | Hello Sunshine",
      siteName: "Hello Sunshine",
      social: {
        facebook: "https://www.facebook.com/hellosunshinenl/",
      },
      cookie: {
        prefix: "hs-",
      },
      list: {
        limit: 50,
      },
      locale: {
        NL: "nl",
      },
      search: {
        minimumChars: 3,
      },
    },
  };
};
